<template>
  <div class="consent-payer-page">
    <div class="consent-information-form-container">
      <div class="consent-title">ข้อความยินยอม</div>

      <!-- pay for one insured -->
      <div class="consent-description" v-if="!isCombinePayment">
        ข้าพเจ้า
        <span class="highlight-word">{{ payerInformation.name }}</span> เลขที่บัตรประชาชน/Passport
        <span class="highlight-word">{{ payerInformation.citizenId }}</span> ซึ่งมีความสัมพันธ์เป็น
        <span class="highlight-word">{{ payerInformation.relationship }}</span>
        ของผู้เอาประกันภัยชื่อ
        <span class="highlight-word">{{ insuredInformation[0].name }}</span> มีความประสงค์ขอชำระ
        เบี้ยประกันภัย <span class="highlight-word">สุขภาพ</span> แผน
        <span class="highlight-word">{{ insurancePlanName }} </span>
        ให้กับผู้เอาประกันภัยโดยข้าพเจ้ายินยอมให้บริษัทประกัน
        ทำการหักเงินค่าเบี้ยประกันภัยของข้าพเจ้าตามวิธีการที่ข้าพเจ้าได้ระบุไว้ข้างต้น
      </div>

      <!-- pay for all insured -->
      <div class="consent-description combine-payment" v-else>
        ข้าพเจ้า
        <span class="highlight-word">{{ payerInformation.name }}</span> เลขที่บัตรประชาชน/Passport
        <span class="highlight-word">{{ payerInformation.citizenId }}</span>
        มีความประสงค์ขอชำระ เบี้ยประกันภัย
        <span class="highlight-word">สุขภาพ</span> แผน
        <span class="highlight-word">{{ insurancePlanName }}</span> ให้กับผู้เอาประกันภัยตามรายชื่อ
        ดังนี้
        <div class="insured-information-section">
          <div
            class="insured-information"
            v-for="(insuredDetail, idx) in insuredInformation"
            :key="insuredDetail.id"
          >
            {{ idx + 1 }}.
            <span class="highlight-word">{{ insuredDetail.name }}</span> ข้อมูลตามใบคำขอเลขที่
            <span class="highlight-word">{{ insuredDetail.applicationId }}</span> ซึ่งข้าพเจ้า
            มีความสัมพันธ์เป็น
            <span class="highlight-word">{{ insuredDetail.relationship }}</span> ของผู้เอาประกันภัย
          </div>
        </div>
        <div class="inform-text">
          โดยข้าพเจ้ายินยอมให้บริษัทประกัน
          ทำการหักเงินค่าเบี้ยประกันภัยของข้าพเจ้าตามวิธีการที่ข้าพเจ้าได้ระบุไว้ข้างต้น
        </div>
      </div>

      <div class="consent-signature-container">
        <div class="consent-signature-title">กรุณาลงนามผู้ชำระเบี้ยประกันภัย</div>
        <vueSignature
          class="consent-signature-section"
          ref="signature"
          :sigOption="options"
          h="200px"
        />
        <div class="signature-clear-btn-container">
          <Button class="signature-clear-btn" type="info" @click.native="clearSignature">
            แก้ไข
          </Button>
        </div>
      </div>
      <div class="consent-submit-btn-container">
        <Button class="consent-submit-btn" @click.native="submitConsentInformation">ยืนยัน</Button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

import Button from '@/components/Button'
import { convertBase64ToBlob } from '@/lib/services'

export default {
  name: 'ConsentPayer',
  props: ['application_id'],
  data() {
    return {
      isCombinePayment: true,
      payerInformation: {},
      insuredInformation: [],
      insurancePlanName: '',
      options: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255, 255, 255)',
      },
    }
  },
  components: {
    Button,
  },
  mounted() {
    this.getApplicationInformation(this.application_id)
  },
  watch: {
    applicationInformation: {
      handler(data) {
        const isCombinePayment = _.get(
          data,
          'applicationInformation.familyQuotation.isCombinePayment',
          false,
        )

        const planName = _.get(data, 'applicationInformation.planPackageScheme.planName', '')

        const payerPersonId = _.get(data, 'applicationInformation.payer.personId', '')
        const payerNamePrefix = _.get(data, 'applicationInformation.payer.title.name', '')
        const payerFirstname = _.get(data, 'applicationInformation.payer.firstname', '')
        const payerLastname = _.get(data, 'applicationInformation.payer.lastname', '')
        const payerFullname = `${payerNamePrefix || ''} ${payerFirstname} ${payerLastname}`.trim()
        const payerIdentityNumber = _.get(data, 'applicationInformation.payer.identityNumber', '')
        const payerRelationship = _.get(
          data,
          'applicationInformation.application.payerRelationshipId.description',
          '',
        )

        if (isCombinePayment) {
          const familyQuotations = _.get(
            data,
            'applicationInformation.familyQuotation.quotations',
            [],
          )

          const isPaidByInsuredPerson = data.applicationInformation.quotation.isPaidByInsuredPerson

          this.insuredInformation = _.map(familyQuotations, data => ({
            id: data.insuredPersonId,
            name: `${data.insuredTitle || ''} ${data.insuredFirstname} ${
              data.insuredLastname
            }`.trim(),
            relationship: data.payerRelationshipDescription,
            applicationId: data.applicationId,
          }))

          if (isPaidByInsuredPerson) {
            this.insuredInformation = _.drop(this.insuredInformation)
          } else {
            this.insuredInformation = _.filter(
              this.insuredInformation,
              insuredData => insuredData.name !== payerFullname,
            )
          }
        } else {
          const insuredPersonId = _.get(data, 'applicationInformation.insuredPerson.personId', '')
          const insuredNamePrefix = _.get(
            data,
            'applicationInformation.insuredPerson.title.name',
            '',
          )
          const insuredTitle = _.get(data, 'applicationInformation.insuredPerson.title.name', '')
          const insuredFirstname = _.get(data, 'applicationInformation.insuredPerson.firstname', '')
          const insuredLastname = _.get(data, 'applicationInformation.insuredPerson.lastname', '')

          const insuredFullname = `${insuredTitle} ${insuredFirstname} ${insuredLastname}`.trim()

          const personInformation = {
            id: insuredPersonId,
            name: insuredFullname,
            applicationId: this.application_id,
          }

          this.insuredInformation = _.concat(this.insuredInformation, personInformation)
        }

        this.isCombinePayment = Boolean(isCombinePayment)

        this.payerInformation = {
          id: payerPersonId,
          name: payerFullname,
          citizenId: payerIdentityNumber,
          relationship: payerRelationship,
        }

        this.insurancePlanName = planName
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['applicationInformation']),
  },
  methods: {
    ...mapActions([
      'getFamilyRelationship',
      'getApplicationInformation',
      'updateConsentPayerInformation',
    ]),
    clearSignature() {
      this.$refs.signature.clear()
    },
    submitConsentInformation() {
      if (!this.$refs.signature.isEmpty()) {
        const consentImageData = this.$refs.signature.save()

        const imageBlock = consentImageData.split(';')
        const contentType = imageBlock[0].split(':')[1]
        const realData = imageBlock[1].split(',')[1]
        const blob = convertBase64ToBlob(realData, contentType)
        const FormImageData = new FormData()

        FormImageData.append('image', blob)

        this.updateConsentPayerInformation(FormImageData)
      } else {
        this.$swal({
          type: 'error',
          title: 'กรุณาเซ็นต์ยืนยัน',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.consent-payer-page {
  padding-top: 48px;

  .consent-information-form-container {
    background-color: #fff;
    margin: 0 auto;
    padding: 32px 48px;
    width: 80%;

    .consent-title {
      font-family: 'psl_kanda_extraregular';
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
      text-align: center;
    }

    .consent-description {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 24px;
      text-indent: 50px;

      .highlight-word {
        font-family: 'psl_kanda_extraregular';
      }

      .inform-text {
        margin-top: 24px;
      }

      &.combine-payment {
        .insured-information-section {
          .insured-information {
            text-indent: 32px;
          }
        }
      }
    }

    .consent-signature-container {
      margin-bottom: 24px;
      position: relative;

      .consent-signature-title {
        font-family: 'psl_kanda_extraregular';
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 12px;
        text-align: center;
      }

      .consent-signature-section {
        border: 1px solid #c5c5c5;
        border-radius: 3px;
      }

      .signature-clear-btn-container {
        position: absolute;
        top: 35px;
        right: 5px;

        .signature-clear-btn {
          min-width: 60px;
        }
      }
    }

    .consent-submit-btn-container {
      text-align: center;
    }
  }
}
</style>
